import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import FreeFireGiveaway from "../pages/free-fire-giveaway/page";
import BGMIGiveaway from "../pages/bgmi-giveaway/page";
import TechBlog from "../pages/tech-blog/page";
import About from "../pages/about/page";
import Contact from "../pages/contact/page";
import PrivacyPolicy from "../pages/privacy-policy/page";
import TermsConditions from "../pages/terms-conditions/page";
import Disclaimer from "../pages/disclaimer/page";
import InstagramReelsViralTips from "../pages/tech-blog/articles/instagram-reels-viral-tips/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/free-fire-giveaway",
    element: <FreeFireGiveaway />,
  },
  {
    path: "/bgmi-giveaway",
    element: <BGMIGiveaway />,
  },
  {
    path: "/tech-blog",
    element: <TechBlog />,
  },
  {
    path: "/tech-blog/instagram-reels-viral-tips",
    element: <InstagramReelsViralTips />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "/privacy-policy",
    element: <PrivacyPolicy />,
  },
  {
    path: "/terms-conditions",
    element: <TermsConditions />,
  },
  {
    path: "/disclaimer",
    element: <Disclaimer />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
